import type { ThreadBehaviour } from './shared-responder-v2-core-thread-behaviour';
import { CHOICE_THREAD_BEHAVIOUR } from './shared-responder-v2-core-thread-choice';
import { CONTACT_INFO_THREAD_BEHAVIOUR } from './shared-responder-v2-core-thread-contact-info';
import { IMAGE_CHOICE_THREAD_BEHAVIOUR } from './shared-responder-v2-core-thread-image-choice';
import { MATRIX_THREAD_BEHAVIOUR } from './shared-responder-v2-core-thread-matrix';
import { MESSAGE_THREAD_BEHAVIOUR } from './shared-responder-v2-core-thread-message';
import { MOBILE_APP_THREAD_BEHAVIOUR } from './shared-responder-v2-core-thread-mobile-app';
import { OPEN_ENDED_THREAD_BEHAVIOUR } from './shared-responder-v2-core-thread-open-ended';
import { RANKING_THREAD_BEHAVIOUR } from './shared-responder-v2-core-thread-ranking';
import { RATING_THREAD_BEHAVIOUR } from './shared-responder-v2-core-thread-rating';
import { TASK_THREAD_BEHAVIOUR } from './shared-responder-v2-core-thread-task';
import { URL_THREAD_BEHAVIOUR } from './shared-responder-v2-core-thread-url';
import {
  THREAD_KINDS,
  type ThreadKind,
} from './shared-responder-v2-core-thread.consts';

/**
 * The one place that grows when a question kind is added. Typing this as an
 * exhaustive `Record<ThreadKind, …>` makes a forgotten kind a compile error
 * rather than a runtime surprise, which is why the session reducer can ask the
 * registry instead of switching on kind itself.
 */
export const THREAD_BEHAVIOURS: Readonly<Record<ThreadKind, ThreadBehaviour>> =
  {
    [THREAD_KINDS.Choice]: CHOICE_THREAD_BEHAVIOUR,
    [THREAD_KINDS.ImageChoice]: IMAGE_CHOICE_THREAD_BEHAVIOUR,
    [THREAD_KINDS.Rating]: RATING_THREAD_BEHAVIOUR,
    [THREAD_KINDS.Matrix]: MATRIX_THREAD_BEHAVIOUR,
    [THREAD_KINDS.Ranking]: RANKING_THREAD_BEHAVIOUR,
    [THREAD_KINDS.OpenEnded]: OPEN_ENDED_THREAD_BEHAVIOUR,
    [THREAD_KINDS.ContactInfo]: CONTACT_INFO_THREAD_BEHAVIOUR,
    [THREAD_KINDS.Message]: MESSAGE_THREAD_BEHAVIOUR,
    [THREAD_KINDS.Task]: TASK_THREAD_BEHAVIOUR,
    [THREAD_KINDS.Url]: URL_THREAD_BEHAVIOUR,
    [THREAD_KINDS.MobileApp]: MOBILE_APP_THREAD_BEHAVIOUR,
  };

export function getThreadBehaviour(kind: ThreadKind): ThreadBehaviour {
  return THREAD_BEHAVIOURS[kind];
}
